/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".home[_ngcontent-%COMP%]{font-family:MedievalSharp,cursive;font-size:large}.app-container[_ngcontent-%COMP%]{display:flex;min-height:100vh;flex-direction:column}.content-container[_ngcontent-%COMP%]{flex:1;position:relative}.content[_ngcontent-%COMP%]{padding:16px 20px 10px}.connected-user-information[_ngcontent-%COMP%]{padding:0 20px}"];
export { styles as styles };
